import { Container } from '../../ui'
import cn from 'classnames'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'
import { reviews } from './constants/reviews'

import 'swiper/css'
import 'swiper/css/navigation'

import { ReactComponent as ArrowIcon } from './assets/images/arrow.svg'

import c from './assets/sass/reivews.module.scss'

const Reviews = () => {
    return (
        <section id="reviews" className={c.component}>
            <Container>
                <div className={c.title}>Отзывы</div>
                <div className={c.subtitle}>О нас говорят</div>
                <a
                    className={c.info}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://yandex.ru/maps/org/dl_massage/159475417300/reviews/?ll=37.661221%2C55.762688&z=17"
                >
                    <div className={c.infoText}>Рейтинг 5.0</div>
                    <div className={c.infoText}>93 оценки</div>
                </a>
                <div className={c.slider}>
                    <Swiper
                        modules={[Navigation, Pagination]}
                        breakpoints={{
                            0: {
                                slidesPerView: 'auto',
                            },
                            1000: {
                                slidesPerView: 3,
                            },
                        }}
                        spaceBetween={24}
                        loop={true}
                        navigation={{
                            prevEl: `.${c.prev}`,
                            nextEl: `.${c.next}`,
                        }}
                        pagination={{
                            el: `.${c.pagination}`,
                            clickable: true,
                            bulletElement: 'li',
                            bulletClass: c.bullet,
                            bulletActiveClass: c.bulletActive,
                        }}
                    >
                        {reviews.map((review) => (
                            <SwiperSlide key={review.id}>
                                <div className={c.slide}>
                                    <div className={c.slideTop}>
                                        <div className={c.slideAvatar}>
                                            <img
                                                src="/avatar/avatar-01.png"
                                                alt={review.author}
                                            />
                                        </div>
                                        <div className={c.slideInfo}>
                                            <div className={c.slideAuthor}>
                                                {review.author}
                                            </div>
                                            <div className={c.slideDate}>
                                                {review.date}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className={cn(
                                            c.slideRating,
                                            c.fiveStars
                                        )}
                                    />
                                    <div className={c.slideText}>
                                        {review.text}{' '}
                                        <a
                                            href={review.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            еще
                                        </a>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className={c.sliderBottom}>
                        <button className={cn(c.control, c.prev)}>
                            <ArrowIcon className={c.arrowIcon} />
                        </button>
                        <ul className={c.pagination}></ul>
                        <button className={cn(c.control, c.next)}>
                            <ArrowIcon className={c.arrowIcon} />
                        </button>
                    </div>
                </div>
            </Container>
        </section>
    )
}

export default Reviews
